<template>
  <svg
    class="absolute inset-0 w-full h-full z-[-1]"
    xmlns="http://www.w3.org/2000/svg"
    :style="svgStyle"
  >
    <defs>
      <pattern
        id="dot-pattern"
        x="-100"
        y="-1"
        width="30"
        height="30"
        patternUnits="userSpaceOnUse"
      >
        <circle cx="1.5" cy="1.5" r="1.5" fill="#d3d3d3" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#dot-pattern)" />
  </svg>
</template>

<script setup>
import { computed } from "vue";
import { useVueFlow } from "@vue-flow/core";

const { viewport } = useVueFlow();

// Sync pan and zoom with background transform
const svgStyle = computed(() => {
  const { x, y, zoom } = viewport.value;
  return {
    transform: `translate(${x}px, ${y}px) scale(${zoom})`,
    transformOrigin: "0 0",
    width: "2000px",
    height: "2000px",
    overflow: "hidden",
  };
});
</script>

<style scoped>
svg {
  pointer-events: none;
}
</style>
